"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"

// Custom SVG Icons as components
const PencilIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
)

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
    <path d="M12,11L16,15H13V19H11V15H8L12,11Z" />
  </svg>
)

const DownloadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
  </svg>
)

const PaymentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4M20,18H4V12H20V18M20,8H4V6H20V8Z" />
  </svg>
)

const HomeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" />
  </svg>
)

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
  </svg>
)

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
  </svg>
)

const ArrowLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
  </svg>
)

const ShoppingCartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5H5.21L4.27,3H1M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z" />
  </svg>
)

const LogOutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
  </svg>
)

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
  </svg>
)

// Merit Transfer Icons
const HeartIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5 2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" />
  </svg>
)

const FlowerIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" />
  </svg>
)

const CandleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9.5,3A1.5,1.5 0 0,0 8,4.5V5.5A1.5,1.5 0 0,0 9.5,7A1.5,1.5 0 0,0 11,5.5V4.5A1.5,1.5 0 0,0 9.5,3M12,2C13.11,2 14,2.89 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4C10,2.89 10.89,2 12,2M17,7H7A2,2 0 0,0 5,9V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V9A2,2 0 0,0 17,7Z" />
  </svg>
)

const PeaceIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z" />
  </svg>
)

const Homarequests = () => {
  const [activeMenuItem, setActiveMenuItem] = useState("Online Prayer Requests")
  const [isMobile, setIsMobile] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
      if (window.innerWidth >= 768) {
        setSidebarOpen(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const menuItems = [
    { name: "Home", icon: HomeIcon, hasSubmenu: true },
    { name: "Online Prayer Requests", icon: PencilIcon, hasSubmenu: true },
    { name: "Upload Prayer Forms", icon: UploadIcon, hasSubmenu: false },
    { name: "Download Prayer Forms", icon: DownloadIcon, hasSubmenu: true },
    { name: "Payments & Offerings", icon: PaymentIcon, hasSubmenu: false },
    { name: "My Basket", icon: ShoppingCartIcon, hasSubmenu: false },
    { name: "Sign Out", icon: LogOutIcon, hasSubmenu: false },
  ]

  const styles = {
    container: {
      display: "flex",
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      fontFamily: "Arial, sans-serif",
      position: "relative",
    },
    header: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "80px",
      backgroundColor: "#6b7280",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 20px",
      zIndex: 1000,
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    headerLeft: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    headerRight: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    menuButton: {
      background: "none",
      border: "none",
      color: "white",
      fontSize: "1.5rem",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      padding: "8px",
    },
    goBackButton: {
      background: "none",
      border: "none",
      color: "white",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
      fontSize: "1rem",
      padding: "8px 12px",
    },
    cartIcon: {
      position: "relative",
      color: "white",
      fontSize: "1.5rem",
      cursor: "pointer",
      padding: "8px",
    },
    cartBadge: {
      position: "absolute",
      top: "0px",
      right: "0px",
      backgroundColor: "#ef4444",
      color: "white",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      fontSize: "0.75rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    signOutButton: {
      backgroundColor: "#9ca3af",
      color: "white",
      border: "none",
      padding: "8px 16px",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "0.9rem",
    },
    sidebar: {
      backgroundColor: "#7fb3a3",
      paddingTop: "80px",
      minHeight: "100vh",
      position: "fixed",
      width: isMobile ? "80%" : "250px",
      left: isMobile ? (sidebarOpen ? "0" : "-100%") : "0",
      transition: "left 0.3s ease",
      zIndex: 999,
      overflowY: "auto",
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 998,
      display: isMobile && sidebarOpen ? "block" : "none",
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "15px 20px",
      color: "white",
      cursor: "pointer",
      borderBottom: "1px solid rgba(255,255,255,0.1)",
      fontSize: "0.95rem",
      transition: "background-color 0.2s",
      borderTopLeftRadius: "30px",
      borderBottomLeftRadius: "30px",
      marginBottom: "20px",
    },
    menuItemActive: {
      backgroundColor: "#4b5563",
    },
    menuItemLeft: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    mainContent: {
      marginLeft: isMobile ? "0" : "250px",
      paddingTop: "80px",
      flex: 1,
      padding: isMobile ? "20px" : "30px",
      width: isMobile ? "100%" : "calc(100% - 250px)",
    },
    pageTitle: {
      fontSize: "32px",
      fontWeight: "700",
      color: "#374151",
      textAlign: "center",
      marginBottom: "8px",
    },
    pageSubtitle: {
      fontSize: "18px",
      color: "#6b7280",
      textAlign: "center",
      marginBottom: "48px",
    },
    buttonContainer: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
      gap: "24px",
      maxWidth: "1000px",
      margin: "0 auto",
      padding: "20px",
    },
    meritButton: {
      backgroundColor: "white",
      border: "2px solid #7fb3a3",
      borderRadius: "16px",
      padding: "24px 20px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      textAlign: "center",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "12px",
      minHeight: "200px",
    },
    regularMeritButton: {
      border: "2px solid #7fb3a3",
    },
    disasterMeritButton: {
      border: "2px solid #ef4444",
    },
    memorialMeritButton: {
      border: "2px solid #8b5cf6",
    },
    newlyDepartedButton: {
      border: "2px solid #f59e0b",
    },
    buttonIcon: {
      marginBottom: "8px",
    },
    regularIcon: {
      color: "#7fb3a3",
    },
    disasterIcon: {
      color: "#ef4444",
    },
    memorialIcon: {
      color: "#8b5cf6",
    },
    newlyDepartedIcon: {
      color: "#f59e0b",
    },
    buttonTitle: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#374151",
      marginBottom: "8px",
      lineHeight: "1.3",
    },
    buttonDescription: {
      fontSize: "14px",
      color: "#6b7280",
      lineHeight: "1.4",
    },
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerLeft}>
          <button style={styles.menuButton} onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
          <img
            src="/logo.png"
            alt="Shinnyo Logo"
            style={{
              height: "60px",
              objectFit: "contain",
              display: isMobile && sidebarOpen ? "none" : "block",
            }}
          />
          {!isMobile && (
            <button style={styles.goBackButton} onClick={() => window.history.back()}>
              <ArrowLeftIcon />
              Go Back
            </button>
          )}
        </div>

        <div style={styles.headerRight}>
          <div style={styles.cartIcon} onClick={() => navigate("/basket")}>
            <ShoppingCartIcon />
            <span style={styles.cartBadge}>0</span>
          </div>
          <button style={styles.signOutButton} onClick={() => navigate("/login")}>
            Sign Out
          </button>
        </div>
      </header>

      {/* Sidebar Overlay */}
      {isMobile && <div style={styles.overlay} onClick={() => setSidebarOpen(false)} />}

      {/* Sidebar */}
      <nav style={styles.sidebar}>
        {menuItems.map((item, index) => {
          const IconComponent = item.icon
          return (
            <div
              key={index}
              style={{
                ...styles.menuItem,
                ...(activeMenuItem === item.name ? styles.menuItemActive : {}),
              }}
              onClick={() => {
                setActiveMenuItem(item.name)
                if (isMobile) setSidebarOpen(false)
                if (item.name === "My Basket") {
                  navigate("/basket")
                } else if (item.name === "Home") {
                  navigate("/home")
                } else if (item.name === "Sign Out") {
                  navigate("/login")
                } else if (item.name === "Online Prayer Requests") {
                  navigate("/#")
                } else if (item.name === "Upload Prayer Forms") {
                  navigate("/upload-forms")
                } else if (item.name === "Download Prayer Forms") {
                  navigate("/download-forms")
                } else if (item.name === "Payments & Offerings") {
                  navigate("/Offerings")
                }
              }}
              onMouseEnter={(e) => {
                if (activeMenuItem !== item.name) {
                  e.target.style.backgroundColor = "#4b5563"
                }
              }}
              onMouseLeave={(e) => {
                if (activeMenuItem !== item.name) {
                  e.target.style.backgroundColor = "transparent"
                }
              }}
            >
              <div style={styles.menuItemLeft}>
                <IconComponent />
                <span>{item.name}</span>
              </div>
              {item.hasSubmenu && <ChevronRightIcon />}
            </div>
          )
        })}
      </nav>

      {/* Main Content */}
      <main style={styles.mainContent}>
        <h1 style={styles.pageTitle}>Merit Transfer Services</h1>
        <p style={styles.pageSubtitle}>Choose the type of merit transfer service you would like to request</p>

        <div style={styles.buttonContainer}>
          {/* Regular Merit Transfer Button */}
          <div
            style={{
              ...styles.meritButton,
              ...styles.regularMeritButton,
            }}
            onClick={() => navigate("/merittransferregular")}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)"
              e.currentTarget.style.borderColor = "#5f9ea0"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)"
              e.currentTarget.style.borderColor = "#7fb3a3"
            }}
          >
            <div style={{ ...styles.buttonIcon, ...styles.regularIcon }}>
              <HeartIcon />
            </div>
            <h2 style={styles.buttonTitle}>Regular Merit Transfer</h2>
            <p style={styles.buttonDescription}>
              Standard merit transfer service for spiritual blessings and positive karma dedication to loved ones.
            </p>
          </div>

          {/* Special Merit Transfer for Disaster Victims Button */}
          <div
            style={{
              ...styles.meritButton,
              ...styles.disasterMeritButton,
            }}
            onClick={() => navigate("/disasterprayerrequest")}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)"
              e.currentTarget.style.borderColor = "#dc2626"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)"
              e.currentTarget.style.borderColor = "#ef4444"
            }}
          >
            <div style={{ ...styles.buttonIcon, ...styles.disasterIcon }}>
              <PeaceIcon />
            </div>
            <h2 style={styles.buttonTitle}>
              Special Merit Transfer for Victims of Disaster Within First 100 Days Passing
            </h2>
            <p style={styles.buttonDescription}>
              Dedicated merit transfer service for those who have passed away due to disasters within the first 100
              days.
            </p>
          </div>

          {/* Merit Transfer Anniversary Button */}
          <div
            style={{
              ...styles.meritButton,
              ...styles.memorialMeritButton,
            }}
            onClick={() => navigate("/merittransfermemorial")}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)"
              e.currentTarget.style.borderColor = "#7c3aed"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)"
              e.currentTarget.style.borderColor = "#8b5cf6"
            }}
          >
            <div style={{ ...styles.buttonIcon, ...styles.memorialIcon }}>
              <FlowerIcon />
            </div>
            <h2 style={styles.buttonTitle}>Merit Transfer Marking the Anniversary of Death</h2>
            <p style={styles.buttonDescription}>
              Memorial service for honoring and transferring merit on the anniversary of a loved one's passing.
            </p>
          </div>

          {/* Merit Transfer for Newly Departed Button */}
          <div
            style={{
              ...styles.meritButton,
              ...styles.newlyDepartedButton,
            }}
            onClick={() => navigate("/newlydeparted")}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)"
              e.currentTarget.style.borderColor = "#d97706"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)"
              e.currentTarget.style.borderColor = "#f59e0b"
            }}
          >
            <div style={{ ...styles.buttonIcon, ...styles.newlyDepartedIcon }}>
              <CandleIcon />
            </div>
            <h2 style={styles.buttonTitle}>Merit Transfer for Newly Departed Within First 100 Days</h2>
            <p style={styles.buttonDescription}>
              Special merit transfer service for those who have recently passed away within the first 100 days.
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Homarequests
